import { c as _c } from "react/compiler-runtime";
import { FFTermsOfUse } from "@repo/ui/components/brand/FFTermsOfUse";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/om/villkor")({
  component: RouteComponent
});
function RouteComponent() {
  const $ = _c(2);
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate) {
    const handleBack = () => {
      if (window.opener) {
        window.close();
      } else {
        navigate({
          to: "/"
        });
      }
    };
    t0 = /*#__PURE__*/_jsx(FFTermsOfUse, {
      onBack: handleBack
    });
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}